import { render, staticRenderFns } from "./CardSmall.vue?vue&type=template&id=6a6189c4&"
import script from "./CardSmall.vue?vue&type=script&lang=js&"
export * from "./CardSmall.vue?vue&type=script&lang=js&"
import style0 from "./CardSmall.vue?vue&type=style&index=0&id=6a6189c4&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports